import React, { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import FormRegister from "../../components/Account/formRegister";
import { validatePassword } from "../../utils/passwordPolicy";
import { copyToClipboard } from "../../utils/copyToClipboard";
import { DataContext } from "../../Provider/dataProvider";
import "../../css/account.css";

const RegisterPage = () => {
    const { data } = useContext(DataContext);
    const navigate = useNavigate();
    const [, setFormData] = useState({
        username: "",
        phone: "",
        email: "",
        role: "elderly",
        password: "",
        confirmPassword: "",
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showLinkKey, setShowLinkKey] = useState(false);
    const [linkKey, setLinkKey] = useState('');

    useEffect(() => {
        if (!data?.id) return;
        navigate(data.role === 'elderly' ? '/home_elderly' : '/home_caregiver', { replace: true });
    }, [data, navigate]);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData((previous) => ({ ...previous, [name]: value }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = new FormData(event.currentTarget);
        const payload = Object.fromEntries(form.entries());

        const passwordCheck = validatePassword(payload.password, payload.confirmPassword);
        if (!passwordCheck.valid) {
            setError(passwordCheck.message);
            return;
        }

        delete payload.confirmPassword;

        setLoading(true);
        setError('');

        fetch(`${process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001'}/register`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
        })
            .then((response) => response.json())
            .then((result) => {
                if (!result.success) {
                    throw new Error(result.message || 'Đăng ký thất bại');
                }

                if (result.role === 'elderly' && result.data?.linkKey) {
                    setLinkKey(result.data.linkKey);
                    setShowLinkKey(true);
                } else {
                    navigate('/login');
                }
            })
            .catch((err) => {
                setError(err.message);
            })
            .finally(() => setLoading(false));
    };

    const handleCopyLinkKey = async () => {
        try {
            await copyToClipboard(linkKey);
        } catch {
            // ignore
        }
    };

    if (showLinkKey) {
        return (
            <div className="tamcare-auth-page">
                <div className="tamcare-auth-card tamcare-auth-card--register">
                    <div className="tamcare-auth-card__header tamcare-auth-card__header--center">
                        <h2>Đăng Ký Thành Công! 🎉</h2>
                        <p>Lưu mã kết nối của bạn</p>
                    </div>
                    <div style={{ padding: '2rem', textAlign: 'center' }}>
                        <p style={{ marginBottom: '1.5rem', color: '#666', fontSize: '0.95rem' }}>
                            Chia sẻ mã này với gia đình hoặc người chăm sóc để họ có thể theo dõi sức khỏe của bạn
                        </p>
                        <div style={{
                            background: '#f0f7ff',
                            border: '2px solid #3498db',
                            borderRadius: '8px',
                            padding: '1.5rem',
                            marginBottom: '2rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: '1rem'
                        }}>
                            <span style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#3498db', fontFamily: 'monospace', letterSpacing: '2px' }}>
                                {linkKey}
                            </span>
                            <button
                                type="button"
                                onClick={handleCopyLinkKey}
                                style={{
                                    background: '#3498db',
                                    color: 'white',
                                    border: 'none',
                                    padding: '0.5rem 1rem',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    fontSize: '0.9rem'
                                }}
                            >
                                <i className="fa-solid fa-copy"></i> Sao chép
                            </button>
                        </div>
                        <button
                            type="button"
                            onClick={() => navigate('/login')}
                            style={{
                                background: '#27ae60',
                                color: 'white',
                                border: 'none',
                                padding: '0.75rem 2rem',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '1rem',
                                fontWeight: 'bold'
                            }}
                        >
                            Tiếp tục đăng nhập
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="tamcare-auth-page">
            <Link to="/" className="tamcare-back-home">
                <i className="fa-solid fa-house"></i> Trang chủ
            </Link>
            <FormRegister
                handleSubmit={handleSubmit}
                handleChange={handleChange}
                loading={loading}
                error={error}
            />
        </div>
    );
};

export default RegisterPage;
